import Button from "components/ui/Button";
import { VStack } from "components/Stack";
import { useTranslation } from "react-i18next";

type Props = {
  tm: string | null;
  onNextStep: () => void;
};

function Welcome(props: Props) {
  const { t } = useTranslation();
  const isTeamManager = props.tm === "true";

  return (
    <div className={"welcome-step"}>
      <h1 className={"step-title"}>
        {t(
          isTeamManager
            ? "Auth.invitation.welcomeTeamTitle"
            : "Auth.invitation.welcomeTitle"
        )}
      </h1>

      <VStack className={"content"} align={"center"}>
        <div>
          <p>
            {isTeamManager
              ? t("Auth.invitation.welcomeTeamDescription")
              : t("Auth.invitation.welcomeDescription")}
          </p>

          <ul>
            <li>{t("Auth.invitation.setPassword")}</li>
            <li>{t("Auth.profileDetails.title")}</li>
            <li>
              {isTeamManager
                ? t("Auth.invitation.selectTopics")
                : t("Auth.invitation.selectFocusAreas")}
            </li>
          </ul>

          <Button className="step-action" onClick={props.onNextStep}>
            {t("Auth.invitation.getStarted")}
          </Button>
        </div>
      </VStack>
    </div>
  );
}

export default Welcome;
